import React, { useState } from "react";
import { motion } from "framer-motion";
import "./AboutBanner.css";
import personImg from "../Assets/Enroll-banner-person.png";
import overlayShape from "../Assets/Triangle.png";

const OffersBanner = () => {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const validatePhone = (number) => {
    // Accepts 10 digits, optional +91 or 0 at start
    const regex = /^(\+91|0)?[6-9]\d{9}$/;
    return regex.test(number);
  };

  const handleSubmitt = async (e) => {
    e.preventDefault();

    if (!validatePhone(phone)) {
      setError("Please enter a valid 10-digit mobile number");
      return;
    }

    setError("");
    setLoading(true);

    try {
      const res = await fetch("https://newzealacademy.com/send-callback.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone }),
      });

      const data = await res.json();
      alert(data.message);
      setPhone("");
    } catch (error) {
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      className="Offerse-banner"
      style={{ background: "linear-gradient(90deg, #1B99D4, #093c99)" }}
    >
      <div className="banner-content">
        {/* Animated Heading */}
        <motion.h1
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          Enroll to <br />
          <span> Our Course</span>
        </motion.h1>

        {/* Animated Form */}
        
      </div>

      {/* Images Section */}
      <div className="banner-images">
        <motion.img
          src={overlayShape}
          alt="Overlay Shape"
          className="overlay-shape"
          initial={{ rotate: -180, opacity: 0 }}
          animate={{ rotate: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
        />
        <motion.img
          src={personImg}
          alt="Person"
          className="person-img"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.5, ease: "easeOut" }}
        />
      </div>
    </section>
  );
};

export default OffersBanner;
